import Horizontal from "./Horizontal/index";

const AppLayouts = {
  Horizontal,
};
export default AppLayouts;
